if(typeof crypto === 'undefined') { var e = new Error("Cannot find module 'crypto'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = crypto;